import { Feature } from '@app/interfaces/sys/permission';

const features: Feature[] = [
    {
        name: 'Home',
        key: 'home',
        children: [
            {
                name: 'Home View',
                apis: [],
            },
            {
                name: 'Project Calendar Card',
                apis: [
                    {
                        id: '5eed659c1fd54dba89cbbfece8c852e6',
                        name: 'GET /projects/all',
                    },
                ],
            },
            {
                name: 'Notification Card',
                apis: [
                    {
                        id: 'bfbfd7ca40b34da1b1331c895904af36',
                        name: 'GET /notices',
                    },
                    {
                        id: '53c78a883c084c7997659a258fee7e8a',
                        name: 'PUT /notices/response',
                    },
                    {
                        id: '4945a30272da475facaee932020a47fd',
                        name: 'PUT /notices/batch/readed',
                    },
                ],
            },
            {
                name: 'Latest Project Card',
                apis: [
                    {
                        id: '3244cd52e1564c77ac5ec1a347c9882d',
                        name: 'GET /projects',
                    },
                    {
                        id: '4b2bca4d9b754044a93f719b0d6026f7',
                        name: 'GET /dicts',
                    },
                ],
            },
        ],
    },

    // rm permission
    {
        name: 'Lab Topology',
        key: 'labTopology',
        children: [
            {
                name: 'Lab Topology View',
                apis: [
                    {
                        id: '87407a42859e407a9becaadd2ace3230',
                        name: 'GET /users/all-options',
                    },
                    {
                        id: '0b5dad9872c7476f9b724c1a7f42cb65',
                        name: 'GET /matrices/running',
                    },
                    {
                        id: '112770904ecb47a9906cdcbac7957211',
                        name: 'GET /chambers/all-options',
                    },
                    {
                        id: '05b7274a1c1b4719bee2a8ba4840e0ed',
                        name: 'GET /radios/all-options',
                    },
                    {
                        id: '15ae10dc31b444b383f0ebf43da69537',
                        name: 'GET /dashboards',
                    },
                ],
            },
        ],
    },
    {
        name: 'System Log',
        key: 'systemLog',
        children: [
            {
                name: 'System Log View',
                apis: [
                    {
                        id: '32e1b4ac5bcc4085aff3231eeee92d2a',
                        name: 'GET /log-files',
                    },
                    {
                        id: 'f5640af313794a7fbfa3f489bb250ff2',
                        name: 'GET /log-files/download',
                    },
                ],
            },
        ],
    },
    {
        name: 'Accounts',
        key: 'accounts',
        children: [
            {
                name: 'Account View',
                scope: 'All',
                apis: [
                    {
                        id: '542b2061fca74432be337878a543efb7',
                        name: 'GET /users',
                        scope: 'All',
                    },
                    {
                        id: '45b1e64d96f54091a35151ee57995d30',
                        name: 'GET /teams/all-options',
                    },
                    {
                        id: 'd746048a3bcd43c6a19fd019c5623afd',
                        name: 'GET /roles/all-options',
                    },
                ],
            },
            {
                name: 'Account View',
                scope: 'Team',
                apis: [
                    {
                        id: '542b2061fca74432be337878a543efb7',
                        name: 'GET /users',
                        scope: 'Team',
                    },
                    {
                        id: 'd746048a3bcd43c6a19fd019c5623afd',
                        name: 'GET /roles/all-options',
                    },
                ],
            },
            {
                name: 'Account Create',
                apis: [
                    {
                        id: '61868d143691456ba63186d2e7971318',
                        name: 'POST /users',
                    },
                    {
                        id: '45b1e64d96f54091a35151ee57995d30',
                        name: 'GET /teams/all-options',
                    },
                    {
                        id: 'd746048a3bcd43c6a19fd019c5623afd',
                        name: 'GET /roles/all-options',
                    },
                ],
            },
            {
                name: 'Account Update',
                apis: [
                    {
                        id: 'be87313914f9475db65aaca8a2004165',
                        name: 'PUT /users',
                    },
                    {
                        id: '45b1e64d96f54091a35151ee57995d30',
                        name: 'GET /teams/all-options',
                    },
                    {
                        id: 'd746048a3bcd43c6a19fd019c5623afd',
                        name: 'GET /roles/all-options',
                    },
                    {
                        id: '2889e07f41194be9b2d1dbf7a428a263',
                        name: 'GET /users/ones',
                    },
                ],
            },
            // {
            //     name: 'Account Delete',
            //     apis: [
            //         {
            //             id: 'aac98a7ea6844eae8e3fa149a2fa60d2',
            //             name: 'DELETE /users',
            //         },
            //     ],
            // },
            {
                name: 'Account Reset Password',
                apis: [
                    {
                        id: 'ab26f410e3544450b6104e2ba2b96e51',
                        name: 'DELETE /users/password',
                    },
                ],
            },
            {
                name: 'Account Enable',
                apis: [
                    {
                        id: 'b06ce220777b4c719635fb9815519ac8',
                        name: 'PUT /users/enable',
                    },
                ],
            },
        ],
    },
    {
        name: 'Role',
        key: 'role',
        children: [
            {
                name: 'Role View',
                apis: [
                    {
                        id: 'f076e495aac54598a88d0876e66de734',
                        name: 'GET /roles',
                    },
                ],
            },
            {
                name: 'Role Create',
                apis: [
                    {
                        id: '86526f9958e343088d4d3cbca718e21c',
                        name: 'POST /roles',
                    },
                ],
            },
            {
                name: 'Role Update',
                apis: [
                    {
                        id: 'b8d9515972684ea58d00d96b66c12cb3',
                        name: 'PUT /roles',
                    },
                    {
                        id: '47f308f0f42c497d82dc6d19402ae212',
                        name: 'GET /roles/ones',
                    },
                ],
            },
            {
                name: 'Role Delete',
                apis: [
                    {
                        id: 'd173c49f05744a81b3960187d1580f02',
                        name: 'Delete /roles',
                    },
                ],
            },
            {
                name: 'Role Permission Edit',
                apis: [
                    {
                        id: 'cbbf888f9a544c6f9cdfbaa1b23019ac',
                        name: 'PUT /roles/features',
                    },
                    {
                        id: '47f308f0f42c497d82dc6d19402ae212',
                        name: 'GET /roles/ones',
                    },
                    {
                        id: 'c1983395285b45cea8a067955ee26eb4',
                        name: 'PUT /feature-apis',
                    },
                ],
            },
            // {
            //     name: 'Role Permission Synchronization',
            //     apis: [
            //         {
            //             id: 'c1983395285b45cea8a067955ee26eb4',
            //             name: 'PUT /feature-apis',
            //         },
            //     ],
            // },
        ],
    },
    {
        name: 'Audit Log',
        key: 'auditLog',
        children: [
            {
                name: 'Audit Log View',
                apis: [
                    {
                        id: '27f73333408640d39ac7ef9055712b7a',
                        name: 'GET /audit-records',
                    },
                    {
                        id: '4b2bca4d9b754044a93f719b0d6026f7',
                        name: 'GET /dicts',
                    },
                    {
                        id: '87407a42859e407a9becaadd2ace3230',
                        name: 'GET /users/all-options',
                    },
                ],
            },
        ],
    },
    {
        name: 'Simulator Management',
        key: 'simulatorManagement',
        children: [
            {
                name: 'Simulator View',
                apis: [
                    {
                        id: 'db8da8c3d7fc42939826f2d77a946b3e',
                        name: 'GET /simulators',
                    },
                    {
                        id: '71af6c0d0d7641acbf5167404528ebb5',
                        name: 'GET /simulators/types',
                    },
                ],
            },
            {
                name: 'Simulator Create',
                apis: [
                    {
                        id: 'a427d41d97a64d909e2d1435785376d0',
                        name: 'POST /simulators',
                    },
                    {
                        id: '71af6c0d0d7641acbf5167404528ebb5',
                        name: 'GET /simulators/types',
                    },
                ],
            },
            {
                name: 'Simulator Update',
                apis: [
                    {
                        id: '3f39ce763562401aaf1ee7ca863a4d4c',
                        name: 'PUT /simulators',
                    },
                    {
                        id: '71af6c0d0d7641acbf5167404528ebb5',
                        name: 'GET /simulators/types',
                    },
                    {
                        id: '603d14dc61634de9a9a9817cfb806c4e',
                        name: 'GET /simulators/one',
                    },
                ],
            },
            {
                name: 'Simulator Delete',
                apis: [
                    {
                        id: '18dfba14f4f547b7999dcf2eb1c1fa4f',
                        name: 'Delete /simulators',
                    },
                ],
            },
        ],
    },
    {
        name: 'Matrix Monitor',
        key: 'matrixMonitor',
        children: [
            {
                name: 'Matrix Monitor View',
                apis: [
                    {
                        id: '0b5dad9872c7476f9b724c1a7f42cb65',
                        name: 'GET /matrices/running',
                    },
                    {
                        id: '55dc4e16a3ff42b9a6ed1dec8dd2f422',
                        name: 'GET /matrix-data/monitor',
                    },
                    {
                        id: '65a971c23479438cad31a0d5f10e657a',
                        name: 'GET /matrices/hardware-types',
                    },
                    {
                        id: 'f726497df01944dca13a9aeb01d02636',
                        name: 'PUT /matrix-data/attenuation',
                    },
                    {
                        id: '77f97c8b6c7a4e389b5814e077872b23',
                        name: 'PUT /matrix-data/on-off',
                    },
                    {
                        id: '68dc2594f1754aee9383328f15b41b73',
                        name: 'GET /matrices/experiment-status',
                    },
                ],
            },
            {
                name: 'Matrix Import',
                apis: [
                    {
                        id: '601e90229e0f4fd588ff6ec89ba821d9',
                        name: 'PUT /matrix-data/import',
                    },
                ],
            },
            {
                name: 'Matrix Export',
                apis: [
                    {
                        id: 'd31027bec0254a2c895c0604120f730e',
                        name: 'GET /matrix-data/export',
                    },
                ],
            },
        ],
    },
    {
        name: 'Resource',
        key: 'chamberManagement',
        children: [
            {
                name: 'Resource Import',
                apis: [],
            },
            {
                name: 'Resource Export',
                apis: [],
            },
            {
                name: 'Setting Resource Columns',
                apis: [],
            },
            {
                name: 'Chamber Management',
                children: [
                    {
                        name: 'Chamber View',
                        apis: [
                            {
                                id: 'bfb81736f9624ef4a694512841465b12',
                                name: 'GET /chambers',
                            },
                            {
                                id: 'f345eb58c506411a843fb8d0e2a37252',
                                name: 'GET /chambers/one',
                            },
                            {
                                id: '9543dc5c9cb34fefb4a004d649348b22',
                                name: 'All /lab-monitor/'
                            },
                        ],
                    },
                    {
                        name: 'Chamber Create',
                        apis: [
                            {
                                id: '5613e6d3fff04dca9e63c3f0b33b5448',
                                name: 'POST /chambers',
                            },
                        ],
                    },
                    {
                        name: 'Chamber Update',
                        apis: [
                            {
                                id: '1c80abb9b49948419d5d8f85b806fc4d',
                                name: 'PUT /chambers',
                            },
                        ],
                    },
                    {
                        name: 'Chamber Delete',
                        apis: [
                            {
                                id: '6b31448d558b487c8bfd22d244f7333e',
                                name: 'DELETE /chambers',
                            },
                        ],
                    },
                ],
            },
            {
                name: 'Radio Management',
                children: [
                    {
                        name: 'Radio View',
                        apis: [
                            {
                                id: '2ffe91b9a4d34ae3a2e0c2a6f442afb9',
                                name: 'GET /radios',
                            },
                            {
                                id: 'cba626c1fbd1433592e3fe970f12477c',
                                name: 'GET /radios/one',
                            },
                        ],
                    },
                    {
                        name: 'Radio Create',
                        apis: [
                            {
                                id: '3d215beff8474ca8bd1b612e5a4f1ea1',
                                name: 'POST /radios',
                            },
                        ],
                    },
                    {
                        name: 'Radio Update',
                        apis: [
                            {
                                id: '63597ae5273843049c03713301ea57df',
                                name: 'PUT /radios',
                            },
                        ],
                    },
                    {
                        name: 'Radio Delete',
                        apis: [
                            {
                                id: '14fc20f68d304cf2b61a6865a09d91b1',
                                name: 'POST /radio/delete',
                            },
                        ],
                    },
                    {
                        name: 'Radio Port Edit',
                        apis: [
                            {
                                id: 'f7eb65de59a84fbba2d811eb7f3ca7b8',
                                name: 'PUT /radio-ports',
                            },
                            {
                                id: 'a850bfef735249109694bc186fd1a45c',
                                name: 'PUT /radio-ports/switchDisable',
                            },
                        ],
                    },
                ],
            },
            {
                name: 'Matrix Management',
                children: [
                    {
                        name: 'Matrix View',
                        apis: [
                            {
                                id: '3e3867c3bba2435fb4267f18c97ce7c8',
                                name: 'GET /matrices',
                            },
                        ],
                    },
                    {
                        name: 'Matrix Create',
                        apis: [
                            {
                                id: 'b851e3aba2b44806927a72fd3dcf4f1d',
                                name: 'POST /matrices',
                            },
                            {
                                id: '65a971c23479438cad31a0d5f10e657a',
                                name: 'GET /matrices/hardware-types',
                            },
                        ],
                    },
                    {
                        name: 'Matrix Update',
                        apis: [
                            {
                                id: '65a971c23479438cad31a0d5f10e657a',
                                name: 'GET /matrices/hardware-types',
                            },
                            {
                                id: '92169ad509964ae9bd1825d97bcca380',
                                name: 'PUT /matrices',
                            },
                        ],
                    },
                    {
                        name: 'Matrix Delete',
                        apis: [
                            {
                                id: '56d625dd652d4c5a87658ce1c0fae881',
                                name: 'DELETE /matrices',
                            },
                        ],
                    },
                    {
                        name: 'Matrix Status',
                        apis: [
                            {
                                id: '533fbed0e7154be8b5e632df06e976e2',
                                name: 'PUT /matrices/switch-status',
                            },
                            {
                                id: '68dc2594f1754aee9383328f15b41b73',
                                name: 'GET /matrices/experiment-status',
                            },
                            {
                                id: '8b805cfa87374f799836ae5c2f4e6aa9',
                                name: 'PUT /matrices/status/force-stop',
                            },
                        ],
                    },
                    {
                        name: 'Matrix Log View',
                        apis: [
                            {
                                id: '52dc94bf91a046639e5357bfbf143b19',
                                name: 'GET /matrices/logs',
                            },
                        ],
                    },
                    {
                        name: 'Matrix Connections View',
                        apis: [
                            {
                                id: '428ff71d77f24567b9fe834db5648ed8',
                                name: 'GET /matrix-ports/connections',
                            },
                            {
                                id: 'e4a855bcb02840b0a21d7726f9b3cd8b',
                                name: 'GET /matrix-ports/connections/input',
                            },
                            {
                                id: 'a49a812f9eb5469a8a6da3e1387df6fd',
                                name: 'GET /matrix-ports/connections/output',
                            },
                            {
                                id: '622a578ec6f94a3caa68ef29cd4fea18',
                                name: 'GET /radio-ports/options',
                            },
                            {
                                id: 'cb9900afc3f64a2d93726fe02d543cfc',
                                name: 'GET /chamber-ports/options',
                            },
                            {
                                id: '40c600f7247048aa8b9ca24f2d50d6b5',
                                name: 'PUT /matrix-ports/connections/radio',
                            },
                            {
                                id: '6b1533febb9d44f0ba1353e9a9de8be8',
                                name: 'PUT /matrix-ports/connections/chamber',
                            },
                            {
                                id: '741b332ea59142c6b77f91c4effadfc8',
                                name: 'PUT /matrix-ports/description',
                            },
                        ],
                    },
                    {
                        name: 'Matrix Connections Import',
                        apis: [
                            {
                                id: 'dd95ce77591f45fa9640cc6da81dcf6e',
                                name: 'POST /matrix-ports/import',
                            },
                            {
                                id: '6f592cc57c7a4604baa669b49c493340',
                                name: 'PUT /matrix-ports/import/pre-check',
                            },
                        ],
                    },
                    {
                        name: 'Matrix Connections Export',
                        apis: [
                            {
                                id: '73969390310f4715b6ddca82b03e6876',
                                name: 'GET /matrix-ports/export',
                            },
                        ],
                    },
                ],
            },
            {
                name: 'Scanner Management',
                children: [
                    {
                        name: 'Scanner View',
                        apis: [
                            {
                                id: '9543dc5c9cb34fefb4a004d649348b22',
                                name: 'All /lab-monitor/'
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Base Station Management',
                children: [
                    {
                        name: 'Base Station View',
                        apis: [
                            {
                                id: '202c8ef9c10e4b2c97dfa6f602bbad77',
                                name: 'GET /base-stations',
                            }
                        ]
                    },
                    {
                        name: 'Base Station Create',
                        apis: [
                            {
                                id: '5c7003079d214c5b88b9ed9a7f67629e',
                                name: 'POST /base-stations',
                            },
                        ],
                    },
                    {
                        name: 'Base Station Update',
                        apis: [
                            {
                                id: '116d3ea98f934caa903fc84796b185d0',
                                name: 'PUT /base-stations',
                            },
                        ],
                    },
                    {
                        name: 'Base Station Delete',
                        apis: [
                            {
                                id: 'f369e10f29654bbfb4e5be7293761983',
                                name: 'DELETE /base-stations',
                            },
                        ],
                    },
                ]
            },
            {
                name: 'UE Management',
                children: [
                    {
                        name: 'UE View',
                        apis: [
                            {
                                id: '4af0281048254ce7be4d8e1f576887e9',
                                name: 'GET /ues'
                            }
                        ]
                    },
                    {
                        name: 'UE Create',
                        apis: [
                            {
                                id: '112770904ecb47a9906cdcbac7957211',
                                name: 'GET /chambers/all-options'
                            },
                            {
                                id: 'fdbc6b0dffc74009b2ac25d4157bfe4c',
                                name: 'GET /chamber-servers/ue/list'
                            },
                            {
                                id: '4778afec25834aca8f1147f62f872abc',
                                name: 'POST /ues'
                            }
                        ]
                    },
                    {
                        name: 'UE Update',
                        apis: [
                            {
                                id: '514d1095a0034acc8506c8c8acfb92ff',
                                name: 'PUT /ues'
                            }
                        ]
                    },
                    {
                        name: 'UE Delete',
                        apis: [
                            {
                                id: 'dd4046ac763140c4ab5ca5d2db84a7a6',
                                name: 'DELETE /ues'
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Physical Server Management',
                children: [
                    {
                        name: 'Physical Server View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Server Accessory Management',
                children: [
                    {
                        name: 'Server Accessory View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Test Equipment Management',
                children: [
                    {
                        name: 'Test Equipment View',
                        apis: []
                    },
                ]
            },
            {
                name: 'SFP Management',
                children: [
                    {
                        name: 'SFP View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Switch Router Management',
                children: [
                    {
                        name: 'Switch Router View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Test SIM Management',
                children: [
                    {
                        name: 'Test SIM View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Software Tools Management',
                children: [
                    {
                        name: 'Software Tools View',
                        apis: []
                    },
                ]
            },
            {
                name: 'BBU Management',
                children: [
                    {
                        name: 'BBU View',
                        apis: []
                    },
                ]
            },
            {
                name: 'BBU Accessory Management',
                children: [
                    {
                        name: 'BBU Accessory View',
                        apis: []
                    },
                ]
            },
            {
                name: 'RF Accessory Management',
                children: [
                    {
                        name: 'RF Accessory View',
                        apis: []
                    },
                ]
            },
            {
                name: 'RF Switch Splitter Management',
                children: [
                    {
                        name: 'RF Switch Splitter View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Attenuator Management',
                children: [
                    {
                        name: 'Attenuator View',
                        apis: []
                    },
                ]
            },
            {
                name: 'GPS Amplifier Management',
                children: [
                    {
                        name: 'GPS Amplifier View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Shield Chamber Box Management',
                children: [
                    {
                        name: 'Shield Chamber Box View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Rack Management',
                children: [
                    {
                        name: 'Rack View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Cloud Cluster Platform Management',
                children: [
                    {
                        name: 'Cloud Cluster Platform View',
                        apis: []
                    },
                ]
            },
            {
                name: 'CNF(VNF) Management',
                children: [
                    {
                        name: 'CNF(VNF) View',
                        apis: []
                    },
                ]
            },
            // {
            //     name: 'Chamber Server Management',
            //     children: [
            //         {
            //             name: 'Chamber Server View',
            //             apis: [
            //                 {
            //                     id: '6ac1e110d16048a1a39440187aa1188d',
            //                     name: 'GET /chamber-servers'
            //                 }
            //             ],
            //         },
            //         {
            //             name: 'Chamber Server Create',
            //             apis: [
            //                 {
            //                     id: '112770904ecb47a9906cdcbac7957211',
            //                     name: 'GET /chambers/all-options',
            //                 },
            //                 {
            //                     id: 'a95bcd8ed5f44adba1ff9859bfbf9b75',
            //                     name: 'GET /chamber-servers/health'
            //                 },
            //                 {
            //                     id: '2d2aeab7668a48aea331de14572b7333',
            //                     name: 'POST /chamber-servers'
            //                 },
            //             ]
            //         },
            //         {
            //             name: 'Chamber Server Update',
            //             apis: [
            //                 {
            //                     id: '112770904ecb47a9906cdcbac7957211',
            //                     name: 'GET /chambers/all-options',
            //                 },
            //                 {
            //                     id: 'a95bcd8ed5f44adba1ff9859bfbf9b75',
            //                     name: 'GET /chamber-servers/health'
            //                 },
            //                 {
            //                     id: '13da97e3da8c4e8d8b88122e5fde6478',
            //                     name: 'GET /chamber-servers/one'
            //                 },
            //                 {
            //                     id: '06e8b55c6ceb4b9f98260a0001a44bf0',
            //                     name: 'PUT /chamber-servers'
            //                 },
            //             ]
            //         },
            //         {
            //             name: 'Chamber Server Delete',
            //             apis: [
            //                 {
            //                     id: '27f399381e274719a2bfc01b9591753f',
            //                     name: 'DELETE /chamber-servers'
            //                 }
            //             ]
            //         }
            //     ]
            // }
        ],
    },
    {
        name: 'Resource Tracking',
        key: 'resourceTracking',
        children: [
            {
                name: 'Resource Location',
                children: [
                    {
                        name: 'Resource Location View',
                        apis: [],
                    },
                ],
            },
            {
                name: 'Resource Connection',
                children: [
                    {
                        name: 'Resource Connection View',
                        apis: [],
                    },
                ],
            },
            {
                name: 'Room View',
                children: [
                    {
                        name: 'Room View',
                        apis: [],
                    },
                    {
                        name: 'Room View Setting Resource',
                        apis: [],
                    },
                ],
            },
        ],
    },
    {
        name: 'System Config',
        key: 'systemConfig',
        children: [
            {
                name: 'Customized Resources',
                children: [
                    {
                        name: 'Customized Resources View',
                        apis: []
                    }
                ]
            },
            {
                name: 'Approval Settings',
                children: [
                    {
                        name: 'Approval Settings View',
                        apis: []
                    }
                ]
            },
            {
                name: 'Task Template',
                children: [
                    {
                        name: 'Task Template View',
                        apis: []
                    },
                    {
                        name: 'Task Template Create',
                        apis: []
                    },
                    {
                        name: 'Task Template Update',
                        apis: []
                    },
                    {
                        name: 'Task Template Delete',
                        apis: []
                    }
                ]
            },
            {
                name: 'Resources',
                children: [
                    {
                        name: 'Resources View',
                        apis: []
                    }
                ]
            },
            {
                name: 'Resource Template',
                children: [
                    {
                        name: 'Resource Template View',
                        apis: []
                    },
                    {
                        name: 'Resource Template Create',
                        apis: []
                    },
                    {
                        name: 'Resource Template Update',
                        apis: []
                    },
                    {
                        name: 'Resource Template Delete',
                        apis: []
                    }
                ]
            }
        ],
    },
    {
        name: 'Lab Config',
        key: 'labConfig',
        children: [
            {
                name: 'Lab Management',
                children: [
                    {
                        name: 'Lab Management View',
                        apis: []
                    }
                ]
            },
            {
                name: 'Room Storage Template',
                children: [
                    {
                        name: 'Room Storage Template View',
                        apis: []
                    }
                ]
            },
            {
                name: 'Resource Group',
                children: [
                    {
                        name: 'Resource Group View',
                        apis: []
                    }
                ]
            }
        ],
    },
    {
        name: 'Lab Monitor',
        key: 'labMonitor',
        children: [
            {
                name: 'Lab Monitor View',
                scope: 'All',
                apis: [
                    {
                        id: '9543dc5c9cb34fefb4a004d649348b22',
                        name: 'All /lab-monitor/'
                    },
                    {
                        id: 'c5c56ecf35b5404f88763453e4cc25bb',
                        name: 'Get /lab-monitor/scanning/scanner/events/subscribe'
                    },
                    {
                        id: '112770904ecb47a9906cdcbac7957211',
                        name: 'GET /chambers/all-options',
                    },
                    {
                        id: '3fe115b75b1d4c2a82568c9009243301',
                        name: 'GET /chamber-tools',
                    },
                    {
                        id: '467e463163d1451ab36032f7fbb9c9ad',
                        name: 'PUT /chamber-tools',
                    }
                ],
            },
            {
                name: 'Lab Monitor View',
                scope: 'Self',
                apis: [
                    {
                        id: '9543dc5c9cb34fefb4a004d649348b22',
                        name: 'All /lab-monitor/'
                    },
                    {
                        id: 'c5c56ecf35b5404f88763453e4cc25bb',
                        name: 'Get /lab-monitor/scanning/scanner/events/subscribe'
                    },
                    {
                        id: 'f3c460068e3e4f9cbee25b3596fabce7',
                        name: 'GET /chambers/list',
                    },
                    {
                        id: '3fe115b75b1d4c2a82568c9009243301',
                        name: 'GET /chamber-tools',
                    }
                ],
            },
            {
                name: 'Threshold Global Setting',
                apis: [
                    {
                        id: '9543dc5c9cb34fefb4a004d649348b22',
                        name: 'All /lab-monitor/'
                    }
                ],
            }
        ]
    },
    {
        name: 'Resource Reservation',
        key: 'resourceReservation',
        children: [
            {
                name: 'Resource Reservation Chamber',
                children: [
                    {
                        name: 'Resource Reservation Chamber View',
                        apis: [
                            {
                                id: 'bfb81736f9624ef4a694512841465b12',
                                name: 'GET /chambers',
                            },
                            {
                                id: 'f345eb58c506411a843fb8d0e2a37252',
                                name: 'GET /chambers/one',
                            },
                        ],
                    },
                    {
                        name: 'Resource Reservation Chamber Management',
                        apis: [
                            {
                                id: '87407a42859e407a9becaadd2ace3230',
                                name: 'GET /users/all-options',
                            },
                            {
                                id: 'e5af09bef8754739983d049e68765437',
                                name: 'POST /user-chambers',
                            },
                            {
                                id: '0c6559f5c5db4cdeaa4b21c9e8f423e0',
                                name: 'DELETE /user-chambers',
                            },
                            {
                                id: 'b171193b811549fea61b2251c95be048',
                                name: 'GET /user-radios/candidate-radios',
                            },
                            {
                                id: '31e9b650a12248929160b9e150ecedab',
                                name: 'POST /user-radios',
                            },
                            {
                                id: 'c6ba51502b5c4a6f988430d3bc554d3c',
                                name: 'DELETE /user-radios',
                            },
                        ],
                    },
                ],
            },
            {
                name: 'Resource Reservation Radio',
                children: [
                    {
                        name: 'Resource Reservation Radio View',
                        apis: [
                            {
                                id: '2ffe91b9a4d34ae3a2e0c2a6f442afb9',
                                name: 'GET /radios',
                            },
                            {
                                id: 'cba626c1fbd1433592e3fe970f12477c',
                                name: 'GET /radios/one',
                            },
                        ],
                    },
                    {
                        name: 'Resource Reservation Radio Management',
                        apis: [
                            {
                                id: '87407a42859e407a9becaadd2ace3230',
                                name: 'GET /users/all-options',
                            },
                            {
                                id: '29e758f126824950baf1220bf47c5dd0',
                                name: 'GET /user-chambers/candidate-chambers',
                            },
                            {
                                id: '31e9b650a12248929160b9e150ecedab',
                                name: 'POST /user-radios',
                            },
                            {
                                id: 'e5af09bef8754739983d049e68765437',
                                name: 'POST /user-chambers',
                            },
                            {
                                id: 'c6ba51502b5c4a6f988430d3bc554d3c',
                                name: 'DELETE /user-radios',
                            },
                            {
                                id: '29e758f126824950baf1220bf47c5dd0',
                                name: 'GET /user-chambers/candidate-chambers',
                            },
                            {
                                id: '0c6559f5c5db4cdeaa4b21c9e8f423e0',
                                name: 'DELETE /user-chambers',
                            },
                        ],
                    },
                ],
            },
            {
                name: 'Resource Reservation Engineer',
                children: [
                    {
                        name: 'Resource Reservation Engineer View',
                        apis: [
                            {
                                id: '6817c2d46ca2474bb940877761e76eb7',
                                name: 'GET /user-chambers',
                            },
                            {
                                id: '39e4f918bbbf4caca37c35e8fb93f736',
                                name: 'GET /user-chambers/ones',
                            },
                        ],
                    },
                    {
                        name: 'Resource Reservation Engineer Management',
                        apis: [
                            {
                                id: '112770904ecb47a9906cdcbac7957211',
                                name: 'GET /chambers/all-options',
                            },
                            {
                                id: 'e5af09bef8754739983d049e68765437',
                                name: 'POST /user-chambers',
                            },
                            {
                                id: 'b171193b811549fea61b2251c95be048',
                                name: 'GET /user-radios/candidate-radios',
                            },
                            {
                                id: '31e9b650a12248929160b9e150ecedab',
                                name: 'POST /user-radios',
                            },
                            {
                                id: '0c6559f5c5db4cdeaa4b21c9e8f423e0',
                                name: 'DELETE /user-chambers',
                            },
                            {
                                id: 'c6ba51502b5c4a6f988430d3bc554d3c',
                                name: 'DELETE /user-radios',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        name: 'Radio Testing',
        key: 'radioTesting',
        children: [
            {
                name: 'Radio Testing View',
                apis: [
                    {
                        id: '65a971c23479438cad31a0d5f10e657a',
                        name: 'GET /matrices/hardware-types',
                    },
                    {
                        id: 'f3c460068e3e4f9cbee25b3596fabce7',
                        name: 'GET /chambers/list',
                    },
                    {
                        id: '2f2bfdaa673c47cbb82c02d2f54b4fae',
                        name: 'GET /matrices/chamber-connected',
                    },
                    {
                        id: 'aefd4ea6cdef4402bb6d86416e2e57ff',
                        name: 'GET /matrix-data/radio-testing',
                    },
                    {
                        id: 'f726497df01944dca13a9aeb01d02636',
                        name: 'PUT /matrix-data/attenuation',
                    },
                    {
                        id: '77f97c8b6c7a4e389b5814e077872b23',
                        name: 'PUT /matrix-data/on-off',
                    },
                    {
                        id: '40213935722845ff81dee35a71d7534b',
                        name: 'PUT /matrix-data/max-attenuation',
                    },
                    {
                        id: '1dae088d417940e9b2c0445358fdb209',
                        name: 'PUT /matrix/data/selected',
                    },
                    {
                        id: '489c3caaa15d4aeda0e22b4e2335abbb',
                        name: 'GET /matrix-data/attenuation',
                    },
                    {
                        id: '2037ef30aa8b451096d55732aa35bacd',
                        name: 'GET /user-radios/port-users',
                    },
                ],
            },
        ],
    },
    {
        name: 'Advanced Mobility',
        key: 'advancedMobility',
        children: [
            {
                name: 'Advanced Mobility View',
                scope: 'All',
                apis: [
                    {
                        id: 'a99d1f4c4fb44d3faed6d389465edd92',
                        name: 'GET /experiments',
                        scope: 'All',
                    },
                ],
            },
            {
                name: 'Advanced Mobility View',
                scope: 'Self',
                apis: [
                    {
                        id: 'a99d1f4c4fb44d3faed6d389465edd92',
                        name: 'GET /experiments',
                        scope: 'Self',
                    },
                ],
            },
            {
                name: 'Experiment Create',
                apis: [
                    {
                        id: '65a971c23479438cad31a0d5f10e657a',
                        name: 'GET /matrices/hardware-types',
                    },
                    {
                        id: 'f3c460068e3e4f9cbee25b3596fabce7',
                        name: 'GET /chambers/list',
                    },
                    {
                        id: '2f2bfdaa673c47cbb82c02d2f54b4fae',
                        name: 'GET /matrices/chamber-connected',
                    },
                    {
                        id: 'aefd4ea6cdef4402bb6d86416e2e57ff',
                        name: 'GET /matrix-data/radio-testing',
                    },
                    {
                        id: '9f51c50a354e4698911ca227021b603a',
                        name: 'POST /experiments',
                    },
                    {
                        id: '982cd02f655a444ca7bbcbd5306c8cd6',
                        name: 'PUT /experiments/status',
                    },
                    {
                        id: '8cd94fdf36a1476ba77fe930fd145886',
                        name: 'PUT /experiments/create-and-start',
                    },
                    {
                        id: 'ef63e398849f4db6808d25251f4cd9b1',
                        name: 'PUT /experiments/update-and-start',
                    },
                ],
            },
            {
                name: 'Experiment Update',
                apis: [
                    {
                        id: '9e5bea98daa74350acb81efefa133023',
                        name: 'GET /experiments/para',
                    },
                    {
                        id: '5325d542438745e08fc3936038296d71',
                        name: 'PUT /experiments',
                    },
                    {
                        id: '982cd02f655a444ca7bbcbd5306c8cd6',
                        name: 'PUT /experiments/status',
                    },
                ],
            },
            {
                name: 'Experiment Delete',
                apis: [
                    {
                        id: '115855a2c9ff4f62b094a00f122bafd0',
                        name: 'GET /experiment/delete',
                    },
                ],
            },
            {
                name: 'Experiment Stop',
                apis: [
                    {
                        id: '5325d542438745e08fc3936038296d71',
                        name: 'PUT /experiments',
                    },
                    {
                        id: '982cd02f655a444ca7bbcbd5306c8cd6',
                        name: 'PUT /experiments/status',
                    },
                ],
            },
            {
                name: 'Experiment Start',
                apis: [
                    {
                        id: '5325d542438745e08fc3936038296d71',
                        name: 'PUT /experiments',
                    },
                    {
                        id: '982cd02f655a444ca7bbcbd5306c8cd6',
                        name: 'PUT /experiments/status',
                    },
                    {
                        id: 'ed60e038a720434bb4fc0a2d7dc897c2',
                        name: 'GET /experiments/enable-status',
                    },
                ],
            },
            {
                name: 'Experiment Monitor View',
                apis: [
                    {
                        id: 'ed60e038a720434bb4fc0a2d7dc897c2',
                        name: 'GET /experiments/enable-status',
                    },
                    {
                        id: '8045aee523d0413ab8bf748fe57d2b44',
                        name: 'GET /experiments/monitor',
                    },
                ],
            },
        ],
    },

    {
        name: 'Profile Settings',
        children: [
            {
                name: 'Profile Setting View',
                apis: [
                    {
                        id: 'dbf8101a563d429689116e24496090aa',
                        name: 'PUT /users/password',
                    },
                    {
                        id: 'be87313914f9475db65aaca8a2004165',
                        name: 'PUT /users',
                    },
                    {
                        id: '2889e07f41194be9b2d1dbf7a428a263',
                        name: 'GET /users/one',
                    },
                ],
            },
        ],
    },

    // lm permission
    {
        name: 'Create Admin',
        key: 'createAdmin',
        children: [
            {
                name: 'Create Admin View',
                apis: [],
            }
        ],
    },
    {
        name: 'System Configuration',
        key: 'systemConfiguration',
        children: [
            {
                name: 'System Config View',
                apis: [],
            }
        ],
    },
    {
        name: 'System Database',
        key: 'systemDatabase',
        children: [
            {
                name: 'System Database View',
                apis: [],
            }
        ],
    },
    {
        name: 'System Email',
        key: 'systemEmail',
        children: [
            {
                name: 'System Email View',
                apis: [],
            }
        ],
    },
    {
        name: 'My Task',
        key: 'myTask',
        children: [
            {
                name: 'My Task View',
                apis: []
            },
            {
                name: 'Cell Status View',
                apis: []
            },
            {
                name: 'Radio Power View',
                apis: []
            },
            {
                name: 'Available Chamber View',
                apis: []
            },
            {
                name: 'Available Tester View',
                apis: []
            }
        ]
    },
    {
        name: 'Teams',
        key: 'teams',
        children: [
            {
                name: 'Team View',
                apis: [
                    {
                        id: 'af6bd62e9ae145648ea7b0252d869723',
                        name: 'GET /teams',
                    },
                ],
            },
            {
                name: 'Team Create',
                apis: [
                    {
                        id: 'a190db17e71f46d1bb7218007a8be05a',
                        name: 'POST /teams',
                    },
                ],
            },
            {
                name: 'Team Update',
                apis: [
                    {
                        id: '4b1613a3815d48fab279aa4c6d719987',
                        name: 'PUT /teams',
                    },
                ],
            },
            {
                name: 'Team List View',
                apis: [
                    {
                        id: '542b2061fca74432be337878a543efb7',
                        name: 'GET /users',
                    },
                ],
            },
        ],
    },
    {
        name: 'Application',
        key: 'application',
        children: [
            {
                name: 'Application View',
                apis: []
            }
        ]
    },
    {
        name: 'Project',
        key: 'project',
        children: [
            {
                name: 'Project List',
                children: [
                    {
                        name: 'Project View',
                        apis: [
                            {
                                id: '3244cd52e1564c77ac5ec1a347c9882d',
                                name: 'GET /projects',
                            },
                            {
                                id: '4b2bca4d9b754044a93f719b0d6026f7',
                                name: 'GET /dicts',
                            },
                        ],
                    },
                    {
                        name: 'Project Create',
                        apis: [
                            {
                                id: '9235ec3fd7934f79acc8ff926428dc21',
                                name: 'POST /projects',
                            },
                            {
                                id: '87407a42859e407a9becaadd2ace3230',
                                name: 'GET /users/all-options',
                                scope: 'Team',
                            },
                        ],
                    },
                    {
                        name: 'Project Update',
                        apis: [
                            {
                                id: '0efcfd7920e948a08bb7650992173ff7',
                                name: 'PUT /projects',
                            },
                            {
                                id: '87407a42859e407a9becaadd2ace3230',
                                name: 'GET /users/all-options',
                                scope: 'Team',
                            },
                        ],
                    },
                    {
                        name: 'Project Delete',
                        apis: [
                            {
                                id: 'db27734bc5074cc6b73a2639c84d3e9a',
                                name: 'Delete /projects',
                            },
                        ],
                    },
                    {
                        name: 'Project Prime Transfer',
                        apis: [],
                    },
                    {
                        name: 'Project Status Change',
                        apis: [],
                    },
                    {
                        name: 'Project Task',
                        children: [
                            {
                                name: 'Project Task View',
                                apis: [
                                    {
                                        id: '1b9f904b8b39470e82d8c004e13f3b18',
                                        name: 'GET /project-tasks',
                                    },
                                ],
                            },
                            {
                                name: 'Project Task Create',
                                apis: [
                                    {
                                        id: '87407a42859e407a9becaadd2ace3230',
                                        name: 'GET /users/all-options',
                                    },
                                    {
                                        id: '4b2bca4d9b754044a93f719b0d6026f7',
                                        name: 'GET /dicts',
                                    },
                                    {
                                        id: '97fcb9b31de24fb4a91089d64ebc1041',
                                        name: 'POST /project-tasks',
                                    },
                                ],
                            },
                            {
                                name: 'Project Task Update',
                                apis: [
                                    {
                                        id: '87407a42859e407a9becaadd2ace3230',
                                        name: 'GET /users/all-options',
                                    },
                                    {
                                        id: '4b2bca4d9b754044a93f719b0d6026f7',
                                        name: 'GET /dicts',
                                    },
                                    {
                                        id: 'c73f9ba8721a43c3b53a9675ac9d23d4',
                                        name: 'PUT /project-tasks',
                                    },
                                ],
                            },
                            {
                                name: 'Project Task Delete',
                                apis: []
                            },
                            {
                                name: 'Project Task Status Change',
                                apis: []
                            },
                            {
                                name: 'Project Task Prime Transfer',
                                apis: []
                            },
                            {
                                name: 'Task Test Case Progress',
                                children: [
                                    {
                                        name: 'Task Test Case Progress View',
                                        apis: []
                                    }
                                ]
                            },
                            {
                                name: 'Task Test Case',
                                children: [
                                    {
                                        name: 'Task Test Case View',
                                        apis: []
                                    }
                                ]
                            },
                            {
                                name: 'Task Document',
                                children: [
                                    {
                                        name: 'Task Document View',
                                        apis: []
                                    },
                                    {
                                        name: 'Task Document Create',
                                        apis: []
                                    },
                                    {
                                        name: 'Task Document Download',
                                        apis: []
                                    },
                                    {
                                        name: 'Task Document Delete',
                                        apis: []
                                    }
                                ]
                            },
                            {
                                name: 'Task Resource',
                                children: [
                                    {
                                        name: 'Task Resource View',
                                        apis: []
                                    },
                                    {
                                        name: 'Task Resource Create',
                                        apis: []
                                    },
                                    {
                                        name: 'Task Resource Release',
                                        apis: []
                                    }
                                ]
                            },
                            {
                                name: 'Task Request View',
                                apis: [],
                            },
                            {
                                name: 'Task Member',
                                children: [
                                    {
                                        name: 'Task Member View',
                                        apis: []
                                    },
                                    {
                                        name: 'Task Member Create',
                                        apis: []
                                    },
                                    {
                                        name: 'Task Member Delete',
                                        apis: []
                                    }
                                ]
                            },
                            {
                                name: 'Task Activity View',
                                apis: []
                            },
                            {
                                name: 'Task Comment View',
                                apis: [],
                            },
                        ],
                    },
                    {
                        name: 'Project Member',
                        children: [
                            {
                                name: 'Project Member View',
                                apis: [],
                            },
                            {
                                name: 'Project Member Create',
                                apis: [],
                            },
                            {
                                name: 'Project Member Remove',
                                apis: [],
                            },
                        ],
                    },
                    {
                        name: 'Project Hardware View',
                        apis: []
                    },
                    {
                        name: 'Project Request View',
                        apis: [],
                    },
                    {
                        name: 'Project Document View',
                        apis: []
                    },
                    {
                        name: 'Project Activity View',
                        apis: []
                    },
                    {
                        name: 'Project Comment View',
                        apis: [],
                    },
                ]
            },
            {
                name: 'Project Draft',
                key: 'project',
                children: [
                    {
                        name: 'Project Draft View',
                        apis: []
                    },
                    {
                        name: 'Project Draft Create',
                        apis: []
                    },
                    {
                        name: 'Project Draft Update',
                        apis: []
                    },
                    {
                        name: 'Project Draft Delete',
                        apis: []
                    }
                ]
            },
            {
                name: 'Project Archived',
                children: [
                    {
                        name: 'Project Archived View',
                        apis: []
                    },
                ]
            },
            {
                name: 'Project Completed',
                children: [
                    {
                        name: 'Project Completed View',
                        apis: []
                    },
                ]
            }
        ],
    },
    {
        name: 'Project Group',
        key: 'projectGroup',
        children: [
            {
                name: 'Project Group View',
                apis: []
            },
            {
                name: 'Project Group Create',
                apis: []
            },
            {
                name: 'Project Group Edit',
                apis: []
            },
            {
                name: 'Project Group Delete',
                apis: []
            }
        ]
    },
    {
        name: 'Team Member',
        key: 'teamMember',
        children: [
            {
                name: 'Team Member View',
                apis: [],
            }
        ],
    },
    {
        name: 'Notification',
        key: 'notification',
        children: [
            {
                name: 'Notification View',
                apis: [
                    {
                        id: 'bfbfd7ca40b34da1b1331c895904af36',
                        name: 'GET /notices',
                    },
                    {
                        id: '53c78a883c084c7997659a258fee7e8a',
                        name: 'PUT /notices/response',
                    },
                    {
                        id: '4945a30272da475facaee932020a47fd',
                        name: 'PUT /notices/batch/readed',
                    },
                ],
            },
        ],
    },
    {
        name: 'Calendar',
        key: 'calendar',
        children: [
            {
                name: 'Calendar View',
                apis: [
                    {
                        id: '05b7274a1c1b4719bee2a8ba4840e0ed',
                        name: 'GET /radios/all-options',
                    },
                    {
                        id: '112770904ecb47a9906cdcbac7957211',
                        name: 'GET /chambers/all-options',
                    },
                ]
            }
        ]
    },
    {
        name: 'Utilization',
        key: 'utilization',
        children: [
            {
                name: 'Utilization View',
                apis: [],
            }
        ],
    },
    {
        name: 'Utilization Tracker',
        key: 'utilizationTracker',
        children: [
            {
                name: 'Utilization Tracker View',
                apis: [],
            },
            {
                name: 'Utilization Tracker Schedule',
                apis: [],
            }
        ],
    },
    {
        name: 'Resource',
        key: 'resource',
        children: [
            {
                name: 'Resource View',
                apis: [],
            }
        ],
    },
    {
        name: 'Location',
        key: 'location',
        children: [
            {
                name: 'Location View',
                apis: [],
            }
        ],
    },
    {
        name: 'Inventory',
        key: 'inventory',
        children: [
            {
                name: 'Inventory View',
                apis: [],
            }
        ],
    },
    {
        name: 'Document',
        key: 'document',
        children: [
            {
                name: 'Document View',
                apis: [],
            },
            {
                name: 'Document Edit',
                apis: []
            }
        ],
    },
    {
        name: 'PSA Management',
        key: 'psaManagement',
        children: [
            {
                name: 'PSA Management View',
                apis: [],
            }
        ],
    },
    {
        name: 'Resource Request',
        key: 'resourceRequest',
        children: [
            {
                name: 'Resource Request View',
                apis: [],
            },
        ],
    },
    {
        name: 'Ticket',
        key: 'ticket',
        children: [
            {
                name: 'Ticket View',
                apis: [],
            },
        ],
    },
    {
        name: 'Repository Management',
        key: 'repositoryManagement',
        children: [
            {
                name: 'Repository Management View',
                apis: [],
            },
            {
                name: 'Repository Create',
                apis: []
            },
            {
                name: 'Repository Edit',
                apis: []
            },
            {
                name: 'Repository Delete',
                apis: []
            }
        ],
    },
    {
        name: 'Floor Map',
        key: 'floorMap',
        children: [
            {
                name: 'Floor Map View',
                apis: [],
            },
            {
                name: 'Floor Map Create',
                apis: []
            },
            {
                name: 'Floor Map Edit',
                apis: []
            },
            {
                name: 'Floor Map Delete',
                apis: []
            }
        ],
    },
    {
        name: 'Kanban Board',
        key: 'kanbanBoard',
        children: [
            {
                name: 'Project',
                children: [
                    {
                        name: 'Kanban Board View',
                        apis: []
                    },
                    {
                        name: 'Kanban Board Create',
                        apis: []
                    },
                    {
                        name: 'Kanban Board Edit',
                        apis: []
                    },
                    {
                        name: 'Kanban Board Delete',
                        apis: []
                    }
                ]
            },
            {
                name: 'Task',
                children: [
                    {
                        name: 'Task View',
                        apis: []
                    },
                    {
                        name: 'Task Create',
                        apis: []
                    },
                    {
                        name: 'Task Edit',
                        apis: []
                    },
                    {
                        name: 'Task Delete',
                        apis: []
                    },
                    {
                        name: 'Task Import CSV',
                        apis: []
                    },
                    // {
                    //     name: 'Task Export CSV',
                    //     apis: []
                    // }
                ]
            },
            {
                name: 'Project Members',
                children: [
                    {
                        name: 'Project Members View',
                        apis: []
                    },
                    {
                        name: 'Project Members Create',
                        apis: []
                    },
                    {
                        name: 'Project Members Edit',
                        apis: []
                    },
                    {
                        name: 'Project Members Delete',
                        apis: []
                    }
                ]
            },
            {
                name: 'Configure Board',
                children: [
                    {
                        name: 'Configure Board View',
                        apis: []
                    }
                ]
            },
        ],
    },
    {
        name: 'Alert',
        key: 'alert',
        children: [
            {
                name: 'Alert View',
                apis: [],
            },
            {
                name: 'Add Alert',
                apis: []
            },
            {
              name: 'Edit Alert',
              apis: []
            },
            {
              name: 'Delete Alert',
              apis: []
            },
            {
              name: 'Enable Alert',
              apis: []
            }
        ],
    },
    {
        name: 'License',
        key: 'license',
        children: [
            {
                name: 'License View',
                apis: [
                    {
                        id: '96e3fa6524bb4da8a5c4d47c63aec44f',
                        name: 'GET /license/features/all',
                    },
                    {
                        id: '0638839f7f0e401fb224ef9e79d25d51',
                        name: 'GET /license',
                    },
                ],
            },
        ],
    }

];

const basicRoleFeatures: {
    [key: string]: {
        features: {
            [key: string]: string[];
        };
    };
} = {
    admin: {
        features: {
            'Account View': [],
            'Account Create': [],
            'Account Update': [],
            // 'Account Delete': [],
            'Account Reset Password': [],
            'Account Enable': [],
            'Role View': [],
            'Role Create': [],
            'Role Update': [],
            'Role Delete': [],
            'Role Permission Edit': [],
            'Role Permission Synchronization': [],
            'License View': [],
            'Profile Setting View': [],
        },
    },
};

export { features, basicRoleFeatures };
